// import React, { useState, useEffect } from 'react';
// import { Grid } from '@mui/material';
// import CardCourse from '../../components/CardCourse';
// import SectionWrapper from '../../components/SectionWrapper';
// import { fetchCourses } from '../../services/courseService';
// import Loader from '../../components/Loader';

// const ProgramsPreview = () => {
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchCourses(setLoading, (data) => {
//       const transformedData = data.slice(0, 3).map(course => ({
//         ...course,
//         image: course.thumbnail || "https://images.unsplash.com/photo-1485083233855-313b198c97e2?w=800&auto=format&fit=crop",
//         category: course.title.toLowerCase().includes("student") ? "AI for Students" :
//                   course.title.toLowerCase().includes("professional") ? "AI for Professionals" :
//                   course.title.toLowerCase().includes("business") || course.title.toLowerCase().includes("leader") ? "AI for Business Leaders" :
//                   course.title.toLowerCase().includes("advanced") || course.title.toLowerCase().includes("expert") ? "Advanced AI Programs" : "AI for Everyone",
//         level: "Beginner",
//         duration: "4 Weeks",
//         price: course.price
//       }));
//       setCourses(transformedData);
//     }, setError);
//   }, []);

//   if (loading) {
//     return (
//       <SectionWrapper title="Our Top Programs" subtitle="Choose from our most requested and highly-rated AI courses designed by industry experts.">
//         <Loader type="skeleton" count={3} />
//       </SectionWrapper>
//     );
//   }

//   if (error || courses.length === 0) return null;

//   return (
//     <SectionWrapper title="Our Top Programs" subtitle="Choose from our most requested and highly-rated AI courses designed by industry experts.">
//       <Grid container spacing={4}>
//         {courses.map((course, index) => (
//           <Grid item xs={12} md={4} key={course.id || index}>
//             <CardCourse {...course} />
//           </Grid>
//         ))}
//       </Grid>
//     </SectionWrapper>
//   );
// };

// export default ProgramsPreview;

import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CardCourse from "../../components/CardCourse";
import SectionWrapper from "../../components/SectionWrapper";
import { fetchCourses } from "../../services/courseService";
import Loader from "../../components/Loader";

const ProgramsPreview = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCourses(
      setLoading,
      (data) => {
        const transformedData = data.slice(0, 3).map((course) => ({
          ...course,
          image: course.title.toLowerCase().includes("basics")
            ? `${process.env.PUBLIC_URL}/images/ai_basics.png`
            : course.title.toLowerCase().includes("full stack")
              ? `${process.env.PUBLIC_URL}/images/fullstack.png`
              : course.title.toLowerCase().includes("healthcare") ||
                  course.title.toLowerCase().includes("imaging")
                ? `${process.env.PUBLIC_URL}/images/ai_healthcare_new.png`
                : course.title.toLowerCase().includes("generative") ||
                    course.title.toLowerCase().includes("creative")
                  ? `${process.env.PUBLIC_URL}/images/generative_ai_arts.png`
                  : course.title.toLowerCase().includes("finance") ||
                      course.title.toLowerCase().includes("trading") ||
                      course.title.toLowerCase().includes("algorithmic")
                    ? "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&auto=format&fit=crop"
                    : course.title.toLowerCase().includes("business") ||
                        course.title.toLowerCase().includes("operations")
                      ? "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop"
                      : course.title.toLowerCase().includes("data") ||
                          course.title.toLowerCase().includes("science")
                        ? `${process.env.PUBLIC_URL}/images/data_science.png`
                        : course.title.toLowerCase().includes("cloud")
                          ? `${process.env.PUBLIC_URL}/images/cloud_computing.png`
                          : course.title.toLowerCase().includes("cyber") ||
                              course.title.toLowerCase().includes("security")
                            ? `${process.env.PUBLIC_URL}/images/cybersecurity.png`
                            : course.thumbnail ? (course.thumbnail.startsWith('http') ? course.thumbnail : `${process.env.PUBLIC_URL}${course.thumbnail}`) :
                              "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&auto=format&fit=crop",
          category: course.title.toLowerCase().includes("student")
            ? "AI for Students"
            : course.title.toLowerCase().includes("professional")
              ? "AI for Professionals"
              : course.title.toLowerCase().includes("business") ||
                  course.title.toLowerCase().includes("leader")
                ? "AI for Business Leaders"
                : course.title.toLowerCase().includes("advanced") ||
                    course.title.toLowerCase().includes("expert")
                  ? "Advanced AI Programs"
                  : "AI for Everyone",
          level: "Beginner",
          duration: "4 Weeks",
          price: course.price,
        }));
        setCourses(transformedData);
      },
      setError,
    );
  }, []);

  if (loading) {
    return (
      <SectionWrapper
        title="Our Top Programs"
        subtitle="Choose from our most requested and highly-rated AI courses designed by industry experts."
      >
        <Loader type="skeleton" count={3} />
      </SectionWrapper>
    );
  }

  if (error || courses.length === 0) return null;

  return (
    <SectionWrapper
      title="Our Top Programs"
      subtitle="Choose from our most requested and highly-rated AI courses designed by industry experts."
    >
      <Grid container spacing={4}>
        {courses.map((course, index) => (
          <Grid item xs={12} md={4} key={course.id || index}>
            <CardCourse {...course} />
          </Grid>
        ))}
      </Grid>
    </SectionWrapper>
  );
};

export default ProgramsPreview;
